const AuthLayoutLoader = () => {
  return (
    <div className="flex h-screen w-full items-center justify-center overflow-y-auto bg-primary-50 p-4 scrollbar-none md:p-6 lg:px-12 lg:py-20">
      <div className="flex w-full max-w-5xl flex-col gap-2 rounded-2xl bg-white p-4 md:flex-row-reverse md:gap-4">
        {/* Image / Illustration section */}
        <div className="hidden flex-1 animate-fade rounded-xl bg-gray-200 md:block" />

        {/* Form section */}
        <div className="flex w-full flex-col gap-6 md:flex-1">
          {/* Logo */}
          <div className="h-10 w-32 animate-fade rounded-lg bg-gray-200" />

          {/* Title */}
          <div className="space-y-3">
            <div className="h-7 w-3/4 animate-fade rounded-md bg-gray-200" />
            <div className="h-4 w-1/2 animate-fade rounded-md bg-gray-200" />
          </div>

          {/* Inputs */}
          <div className="space-y-4">
            <div className="h-12 w-full animate-fade rounded-lg bg-gray-200" />
            <div className="h-12 w-full animate-fade rounded-lg bg-gray-200" />
          </div>

          {/* Button */}
          <div className="h-12 w-full animate-fade rounded-lg bg-gray-200" />

          {/* Footer */}
          <div className="mx-auto h-4 w-2/3 animate-fade rounded-md bg-gray-200" />
        </div>
      </div>
    </div>
  );
};

export default AuthLayoutLoader;
